import { render } from "./VisualRuleBuilderComponent.vue?vue&type=template&id=76e12e4a"
import script from "./VisualRuleBuilderComponent.vue?vue&type=script&lang=js"
export * from "./VisualRuleBuilderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__